// src/utils/evVehicles.js
export const EV_VEHICLES = {
  "2 Wheeler": [
    { brand: "Ather", model: "Ather Rizta S" },
    { brand: "Ather", model: "Ather Rizta Z" },
    { brand: "Ather", model: "Ather 450X" },
    { brand: "Ather", model: "Ather 450 Apex" },
    { brand: "Ather", model: "Ather 450S" },
    { brand: "Ola Electric", model: "Ola S1 X+" },
    { brand: "Ola Electric", model: "Ola S1 Pro" },
    { brand: "Ola Electric", model: "Ola S1 Air" },
    { brand: "Ola Electric", model: "Ola Gig" },
    { brand: "TVS", model: "TVS iQube S" },
    { brand: "TVS", model: "TVS iQube ST" },
    { brand: "TVS", model: "TVS iQube" },
    { brand: "Bajaj", model: "Chetak Premium" },
    { brand: "Bajaj", model: "Chetak Urbane" },
    { brand: "Hero Electric", model: "Hero Vida V1 Pro" },
    { brand: "Hero Electric", model: "Hero Vida V1 Plus" },
    { brand: "Hero Electric", model: "Hero NYX" },
    { brand: "Hero Electric", model: "Hero Optima" },
    { brand: "Revolt", model: "Revolt RV400" },
    { brand: "Revolt", model: "Revolt RV300" },
    { brand: "Okinawa", model: "Okinawa Okhi 90" },
    { brand: "Okinawa", model: "Okinawa Ridge+" },
    { brand: "Ampere", model: "Ampere Nexus" },
    { brand: "Ampere", model: "Ampere Magnus Pro" },
    { brand: "Ampere", model: "Ampere Zeal" },
    { brand: "Simple Energy", model: "Simple One" },
    { brand: "Bounce", model: "Bounce Infinity E1" },
    { brand: "Pure EV", model: "Pure EV eTryst 350" },
    { brand: "Pure EV", model: "Pure EV EPluto 7G" },
    { brand: "Komaki", model: "Komaki Venice" },
    { brand: "", model: "Other (Not Listed)" },
  ],
  "3 Wheeler": [
    { brand: "Piaggio", model: "Piaggio Ape E City" },
    { brand: "Piaggio", model: "Piaggio Ape Electrik" },
    { brand: "Mahindra", model: "Mahindra Treo" },
    { brand: "Mahindra", model: "Mahindra Treo Yaari" },
    { brand: "Mahindra", model: "Mahindra e-Alfa Mini" },
    { brand: "Bajaj", model: "Bajaj RE Electric" },
    { brand: "Kinetic Green", model: "Kinetic Safar Smart" },
    { brand: "Kinetic Green", model: "Kinetic Safar Jumbo" },
    { brand: "Euler Motors", model: "Euler HiLoad" },
    { brand: "Etrio", model: "Etrio Touro Max+" },
    { brand: "Omega Seiki", model: "Omega Rage+" },
    { brand: "", model: "Other (Not Listed)" },
  ],
  "4 Wheeler": [
    { brand: "Tata", model: "Tata Nexon EV" },
    { brand: "Tata", model: "Tata Nexon EV Long Range" },
    { brand: "Tata", model: "Tata Punch EV" },
    { brand: "Tata", model: "Tata Curvv EV" },
    { brand: "Tata", model: "Tata Harrier EV 350" },
    { brand: "Tata", model: "Tata Harrier EV 450" },
    { brand: "Tata", model: "Tata Sierra EV" },
    { brand: "Tata", model: "Tata Tiago EV" },
    { brand: "Tata", model: "Tata Tigor EV" },
    { brand: "MG", model: "MG Windsor EV" },
    { brand: "MG", model: "MG ZS EV" },
    { brand: "MG", model: "MG Comet EV" },
    { brand: "Mahindra", model: "Mahindra BE 6" },
    { brand: "Mahindra", model: "Mahindra XEV 9e" },
    { brand: "BYD", model: "BYD Atto 3" },
    { brand: "BYD", model: "BYD Seal" },
    { brand: "BYD", model: "BYD e6" },
    { brand: "Hyundai", model: "Hyundai Ioniq 5" },
    { brand: "Hyundai", model: "Hyundai Ioniq 6" },
    { brand: "Hyundai", model: "Hyundai Kona Electric" },
    { brand: "Kia", model: "Kia EV6" },
    { brand: "Kia", model: "Kia EV9" },
    { brand: "BMW", model: "BMW iX" },
    { brand: "BMW", model: "BMW i4" },
    { brand: "Mercedes-Benz", model: "Mercedes EQS" },
    { brand: "Mercedes-Benz", model: "Mercedes EQB" },
    { brand: "Audi", model: "Audi e-tron" },
    { brand: "Audi", model: "Audi Q8 e-tron" },
    { brand: "Volvo", model: "Volvo XC40 Recharge" },
    { brand: "Citroen", model: "Citroen eC3" },
    { brand: "", model: "Other (Not Listed)" },
  ],
};

export function getGroupedVehicles(type) {
  const list = EV_VEHICLES[type] || [];
  const groups = {};
  list.forEach((v) => {
    const key = v.brand || "Other";
    if (!groups[key]) groups[key] = [];
    groups[key].push(v.model);
  });
  return groups;
}